export const GET_AVAILABLE_EDOK_MODULES_FAILURE = 'GET_AVAILABLE_EDOK_MODULES_FAILURE';

export const getAvailableEdokModulesFailure = error => ({
    type: GET_AVAILABLE_EDOK_MODULES_FAILURE,
    payload: error,
    error: true,
});
